import React, { useEffect, useState } from "react";

export const Step3 = () => {
  const [pdfbase64, setPdfbase64] = useState<string>("");
  useEffect(() => {
    // Fetch pdf base 64 data from localStorage
    const pdfBase64 = localStorage.getItem("pdfBase64Data");
    // check if pdfBase64 is avariable
    if (pdfBase64) {
      // remove double quotes from the pdfBase64 string
      const modifiedPdfBase64 = pdfBase64.slice(1, -1);
      console.log("modifiedPdfBase64", modifiedPdfBase64);
      // set modifiedPdfBase64 to state
      setPdfbase64(modifiedPdfBase64);
    }
  }, []);
  return (
    <div style={{ height: "100vh" }}>
      <embed
        src={`data:application/pdf;base64,${pdfbase64}`}
        type="application/pdf"
        height="100%"
        width="100%"
      />
    </div>
  );
};

export default Step3;
